import styled from 'styled-components';

import { styledTypography } from '@pkg/primitives';

export const PriceBase = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${styledTypography.allianceFontStack};
`;

export const UsdPrice = styled.div`
    font-weight: bold;
    font-size: 18px;
    line-height: 1;
`;

export const CurrencyIconCircle = styled.div`
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-right: 5px;
    padding: 2px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 0.5em;
    vertical-align: middle;
`;

export const CurrencyPrice = styled.div`
    font-size: 14px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.5);
`;

export const CurrencyPriceValue = styled.span`
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
`;
